import React from "react";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";

const InputGroup = React.memo(
  ({
    className,
    name,
    label,
    inputValue,
    onChange,
    onFocus,
    onBlur,
    onClick,
    disabled,
    inputType,
    leftMargin,
    errors,
    touched,
    height,
    width,
    suffix,
    preTag = false,
    readOnly = false,
    leftMarginValue = "0px",
    placeholder = "",
    minWidth = "unset",
    horizontal = false,
    ignoreTouch = false,
    currency = "",
    style = {},
    dateFormat,
    language,
    details,
    flex,
    showEye,
    preventAutofill = "",
  }) => {
    if (inputValue == null || inputValue === undefined) {
      inputValue = "";
    }
    function getInputGroupClassNames() {
      return classNames({
        [styles.inputGroup]: true,
        [styles.leftMargin]: details,
        [className]: !!className,
      });
    }

    const hasError = errors && errors[name] && (ignoreTouch || touched[name]);
    function renderInput() {
      if (preTag) {
        return <pre>{inputValue}</pre>;
      }
      return (
        <>
          <input
            className={`${
              !(inputType === "textarea") ? styles.input : styles.textarea
            } ${hasError ? styles.error : ""}`}
            type={!inputType ? "text" : inputType}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            value={inputValue}
            disabled={disabled}
            readOnly={readOnly}
            style={{
              width: width ? width : "100%",
              paddingRight: showEye && "30px",
            }}
            placeholder={placeholder}
            autoComplete={preventAutofill}
          />
          {showEye && (
            <i
              onClick={onClick}
              className={`${
                inputType === "password"
                  ? themeStyles.iconEye
                  : themeStyles.iconEyeSlash
              } ${styles.iconEye}`}
            />
          )}
        </>
      );
    }

    return (
      <div
        className={getInputGroupClassNames()}
        style={{ flexGrow: flex, minWidth: minWidth, ...style }}
      >
        <div
          className={styles.padder}
          style={{
            paddingLeft: leftMarginValue,
            flexDirection: horizontal ? "row" : "column",
          }}
        >
          {label && !horizontal && (
            <label
              htmlFor={name}
              className={`${
                horizontal ? styles.inputSuffix : styles.formLabel
              }`}
            >
              {label}
            </label>
          )}
          <div className={styles.horizontalInput}>
            {label && horizontal && (
              <label
                htmlFor={name}
                className={`${
                  horizontal ? styles.inputSuffix : styles.formLabel
                }`}
              >
                {label}
              </label>
            )}
            {renderInput()}{" "}
            {suffix && <span className={styles.inputSuffix}>{suffix}</span>}
          </div>
          {hasError && (
            <small className={styles.errors}>{errors && errors[name]}</small>
          )}
        </div>
      </div>
    );
  }
);

export default InputGroup;
